import { HotTextEvaluator } from 'src/app/classes';
import { PopulationHotText } from '../shared/interfaces/population-hot-text';
import { TEST_CHOICE_TYPES } from './choice-types';
import { TestAssociatedSuccessCriteria } from './test-associated-success-criteria.enum';

export const hotTextQuestions: { [key: number]: PopulationHotText } = {
  [TEST_CHOICE_TYPES.TEST_HOT_TEXT_ONE_WORD]: {
    question: {
      text: 'Read the short story and choose all occurrences of the word "said" each time you see it. (verbal)',
      displayText:
        'Read the short story and choose all occurrences of the word "said" each time you see it. (visual)',
    },
    text: [
      {
        text: '[Sammy wanted] to see a tree. \nBella said, "I see a bug." \nSammy said, "Let us run!" \n[Bella wanted] to see a log. \n Sammy said, "This is fun!"',
      },
    ],
    answers: [['said']],
    associatedSuccessCriteria: [TestAssociatedSuccessCriteria.HOT_TEXT],
    targetedFeedback: {
      firstIncorrect: {
        content: 'This is incorrect 1 - first incorrect targeted feedback',
      },
      secondIncorrect: {
        content: 'This is incorrect 1 - second incorrect targeted feedback',
      },
    },
  },
  [TEST_CHOICE_TYPES.TEST_HOT_TEXT_MULTIPLE_WORDS]: {
    question: {
      text: 'Read the short story and choose all occurrences of the word "correct1" and "correct2" each time you see it. (verbal)',
      displayText:
        'Read the short story and choose all occurrences of the word "correct1" and "correct2" each time you see it. (visual)',
    },
    text: [
      {
        text: '[Sammy said,] "I correct2 a tree." \nBella correct1, "I see a bug." \nSammy correct1, "Let us run!" \n[Bella said,] "I correct2 a log." \n Sammy correct1, "This is fun!"',
      },
    ],
    answers: [['correct1', 'correct2']],
    associatedSuccessCriteria: [TestAssociatedSuccessCriteria.HOT_TEXT],
    targetedFeedback: {
      firstIncorrect: {
        content: 'This is incorrect 1 - first incorrect targeted feedback',
      },
      secondIncorrect: {
        content: 'This is incorrect 1 - second incorrect targeted feedback',
      },
    },
  },
  [TEST_CHOICE_TYPES.TEST_HOT_TEXT_ONE_PHRASE]: {
    question: {
      text: 'Read the short story and choose all occurrences of the phrase "Correct Phrase" each time you see it.',
    },
    text: [
      {
        text: '[Correct Phrase,] "I said a tree." \nBella said, "I see a bug." \nSammy said, "Let us run!" \n[Correct Phrase,] "I see a log." \n Sammy said, "This is fun!"',
      },
    ],
    answers: [['correct Phrase']],
    associatedSuccessCriteria: [TestAssociatedSuccessCriteria.HOT_TEXT],
    targetedFeedback: {
      firstIncorrect: {
        content: 'This is incorrect 1 - first incorrect targeted feedback',
      },
      secondIncorrect: {
        content: 'This is incorrect 1 - second incorrect targeted feedback',
      },
    },
  },
  [TEST_CHOICE_TYPES.TEST_HOT_TEXT_MULTIPLE_PHRASES]: {
    question: {
      text: 'Read the short story and choose all occurrences of the phrase "Correct Phrase1" and "Correct Phrase 2" each time you see it.',
    },
    text: [
      {
        text: '[Correct Phrase1,]     ["I said a tree."] \n     [Incorrect Phrase,] "I see a     bug."  [Correct Phrase1,] "Let us run!" \n[Correct Phrase1,] "I see a log." \n [Correct Phrase 2] said, "This is fun!"',
      },
    ],
    answers: [['correct Phrase1', 'correct Phrase 2']],
    associatedSuccessCriteria: [TestAssociatedSuccessCriteria.HOT_TEXT],
    targetedFeedback: {
      firstIncorrect: {
        content: 'This is incorrect 1 - first incorrect targeted feedback',
      },
      secondIncorrect: {
        content: 'This is incorrect 1 - second incorrect targeted feedback',
      },
    },
  },
  [TEST_CHOICE_TYPES.TEST_HOT_TEXT_MULTIPLE_WORDS_MULTIPLE_PHRASES]: {
    question: {
      text: 'Read the short story and choose all occurrences of the words "correct1" & "correct2" and phrases "Correct Phrase1" and "Correct Phrase 2" in the below passage".',
    },
    text: [
      {
        text: '[Correct Phrase1,] ["I said a tree."] \n[Incorrect Phrase,] "I correct1 a bug."  [Correct Phrase1,] "Let us run!" \n[Correct Phrase1,] "I correct2 a log." \n [Correct Phrase 2] said, "This is correct1!"',
      },
    ],
    answers: [['correct Phrase1', 'correct Phrase 2', 'correct1', 'correct2']],
    associatedSuccessCriteria: [TestAssociatedSuccessCriteria.HOT_TEXT],
    targetedFeedback: {
      firstIncorrect: {
        content: 'This is incorrect 1 - first incorrect targeted feedback',
      },
      secondIncorrect: {
        content: 'This is incorrect 1 - second incorrect targeted feedback',
      },
    },
  },
};

Object.keys(hotTextQuestions).forEach(key => {
  const question = hotTextQuestions[parseInt(key, 10)];
  question.wordsSplit = HotTextEvaluator.splitWordsAndPhrases(
    question.text[0].text
  ) as string[];
});
